import { connect } from "react-redux";
import { Elements } from "react-stripe-elements";

function mapStateToProps(state) {
  const { lang } = state.locales;
  return { locale: lang };
}

export default connect(mapStateToProps)(Elements);
